module.exports = __webpack_public_path__ + "static/media/DataVisualization_001.52c890bf.png";